<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form
        label-width="120px"
        ref="form"
        :model="dataForm"
        :rules="editFormRules"
      >
        <el-form-item label="资助金额：" prop="Amount">
          <el-input
            placeholder="请输入支入金额"
            v-model="dataForm.Amount"
            clearable
            maxlength="100"
            style="width: 220px"
          ></el-input>
        </el-form-item>
        <el-form-item label="资金来源：" prop="Source">
          <el-select
            v-model="dataForm.Source"
            placeholder="请选择"
            style="width: 220px"
          >
            <el-option
              v-for="item in Source"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="拨款公益项目："
          prop="ProjectId"
          v-if="dataForm.Source == 0"
        >
          <el-select
            v-model="dataForm.ProjectId"
            placeholder="请选择"
            style="width: 220px"
          >
            <el-option
              v-for="item in publicWelfare"
              :key="item.Id"
              :label="item.ProjectName"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资助时间：" prop="CreateTime">
          <el-date-picker
            v-model="dataForm.CreateTime"
            type="date"
            value-format="timestamp"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="资助明细：" prop="Describe">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入支出明细"
            v-model="dataForm.Describe"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="附件：" prop="File">
          <el-upload
            class="upload-demo"
            drag
            action="/api/File/FileUpload"
            multiple
            :on-success="onFileUpdate"
            :on-remove="OnFileRemove"
            :on-preview="onFilePreview"
            :file-list="fileList"
            accept=".xls, .doc, .ppt, .xlsx, .docx, .pptx, .txt, .pdf, .zip, .rar"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              支持扩展名：.rar .zip .doc .docx .pdf .jpg...
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import { saveAs } from "file-saver";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    applyModel: {
      type: Object,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editFormRules: {
        Amount: {
          required: true,
          message: "支入金额不能为空",
          trigger: "blur",
        },
        Source: {
          required: true,
          message: "资金来源不能为空",
          trigger: "blur",
        },
        CreateTime: {
          required: true,
          message: "收入时间不能为空",
          trigger: "blur",
        },
        Describe: {
          required: true,
          message: "支出明细不能为空",
          trigger: "blur",
        },
      },
      isConfirm: false,
      width: "60%",
      Source: [
        { value: 0, label: "社会捐赠" },
        { value: 1, label: "财政拨款" },
        { value: 2, label: "其他" },
      ], //资金来源
      dataForm: {}, //表单对象
      fileList: [], //文件上传数组
      publicWelfare: [], //公益项目数组
    };
  },
  components: {
    OfDialog,
    OfUpload,
  },
  mounted() {
    let that = this;
    that.loadPublicWelfare();
  },
  methods: {
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //加载求助项目
    loadPublicWelfare() {
      let that = this;
      api.QueryPublicWelfareByIsDonation().then((res) => {
        if (res.data.Code == 0) {
          that.publicWelfare = res.data.Data;
        }
      });
    },
    //提交
    confirm() {
      let that = this;
      that.$refs.form.validate((valid) => {
        if (valid) {
          that.isConfirm = true;
          let params = Object.assign({}, that.dataForm);
          params.CreateTime = params.CreateTime / 1000;
          params.BigSickApplyId = that.applyModel.Id;
          params.RecipientName = that.applyModel.Name;
          params.ExplainTitle = that.applyModel.Describe;
          if (params.ProjectId) {
            for (var item in that.publicWelfare) {
              if (that.publicWelfare[item].Id == params.ProjectId) {
                params.ProjectName = that.publicWelfare[item].ProjectName;
                break;
              }
            }
          }
          api
            .SaveSickGrant(params)
            .then((res) => {
              that.isConfirm = false;
              if (res.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: res.data.Message,
                  type: "error",
                });
              }
            })
            .catch((e) => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error",
              });
            });
        }
      });
    },
    //初始化附件
    getfile() {
      let that = this;
      if (that.dataForm.File || that.dataForm.File != null) {
        let params = { Id: that.dataForm.File };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.fileList.push({
                url: item.Url,
                name: item.FileName,
                response: response,
              });
            });
          }
        });
      }
    },
    //附件上传
    onFileUpdate(rtnResult) {
      let that = this;
      if (rtnResult.Code == 0) {
        if (!that.dataForm.File && !that.dataForm.File) {
          that.dataForm.File = rtnResult.Data.FileId;
        } else {
          that.dataForm.File += "," + rtnResult.Data.FileId;
        }
        that.$message({
          message: "附件上传成功",
          type: "success",
        });
      }
    },
    //附件删除
    OnFileRemove(file, fileList) {
      let that = this;
      that.dataForm.File = "";
      fileList.forEach((item) => {
        if (that.dataForm.File == "") {
          that.dataForm.File = item.response.Data.FileId;
        } else {
          that.dataForm.File += "," + item.response.Data.FileId;
        }
      });
    },
    //附件下载
    onFilePreview(file) {
      saveAs("/api/File/Download?Id=" + file.response.Data.FileId, file.name);
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.el-date-editor >>> .el-input__icon {
  display: none;
}
.upload-demo >>> .el-upload-dragger {
  width: 270px;
  height: 120px;
}
.upload-demo >>> .el-icon-upload {
  margin: 10px 0 16px;
}
</style>

<style>
.hide {
  display: block !important;
}

.hideFile .el-upload--fileList {
  display: none;
}
</style>